import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://claritypsiholog.com';
const DEFAULT_IMAGE = `${BASE_URL}/images/logo-bird.webp`;

function upsertMeta(attr, value, content) {
  let el = document.querySelector(`meta[${attr}="${value}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

export default function Seo({ title, description }) {
  const location = useLocation();

  useEffect(() => {
    document.title = title;

    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', `${BASE_URL}${location.pathname}`);
    upsertMeta('property', 'og:image', DEFAULT_IMAGE);
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
  }, [title, description, location.pathname]);

  return null;
}
